 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"WX-share":"WX-share"}[chunkId]||chunkId) + "." + {"chunk-2924e8bb":"ce34ae1c","chunk-3839168a":"54ec60cf","chunk-01451fe6":"ad8f24b1","chunk-0292c992":"96c8ae98","chunk-40b44790":"9044e52a","chunk-071eb884":"6776364c","chunk-1efd2608":"2440a1cb","chunk-278c4386":"e6b0ed2d","chunk-31594169":"e229736d","chunk-71a86922":"786d0a33","chunk-3fd7c598":"e8456257","chunk-5ccc31a1":"7c82ba8a","chunk-5fc1159b":"6783860e","chunk-645be826":"0e9affaf","chunk-76c55559":"bd217144","chunk-7e980885":"70418df0","chunk-9207c990":"99479d0c","chunk-33d3ca6e":"59e6029d","chunk-3633e90e":"06779526","chunk-4a2ad8d4":"68d63329","chunk-4d794f61":"1bf412bf","chunk-5880b66b":"30f9994d","chunk-6c14d94f":"86b7ffa6","chunk-792df3cc":"ede29893","chunk-8934895a":"4a69501b","chunk-b6d1c046":"81c87e88","chunk-89394d6c":"5ccd50f9","chunk-8b81e078":"4d463dd9","chunk-5bbfc239":"843a61a1","chunk-a01ae2aa":"5e47f8e9","chunk-cfdb0c12":"79d46ed2","chunk-5af077ff":"c518cad2","chunk-77ed4564":"6e93635a","chunk-3b1e9d03":"9b6bf17d","chunk-4886ce14":"1aa7d1c7","chunk-4e02f188":"35c00ef4","chunk-5962841d":"d1021340","chunk-65f17585":"f267be80","chunk-6a4c442c":"8fe0ddba","chunk-6ac7ad44":"79ea8198","chunk-2c8bb25c":"e32a3188","chunk-7397d7f4":"1f5e10d5","chunk-8893d460":"08bea23b","chunk-8ba736a2":"2c840c7b","chunk-179b2159":"966f2541","chunk-2e8bcc3e":"d231735d","chunk-48e6f5cb":"6ac5c509","chunk-dc5ba90e":"265c17c9","chunk-e11f8508":"2dd7375b","WX-share":"b3f06a7a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-2924e8bb":1,"chunk-01451fe6":1,"chunk-0292c992":1,"chunk-40b44790":1,"chunk-071eb884":1,"chunk-1efd2608":1,"chunk-278c4386":1,"chunk-31594169":1,"chunk-71a86922":1,"chunk-3fd7c598":1,"chunk-5ccc31a1":1,"chunk-5fc1159b":1,"chunk-645be826":1,"chunk-76c55559":1,"chunk-7e980885":1,"chunk-9207c990":1,"chunk-33d3ca6e":1,"chunk-3633e90e":1,"chunk-4a2ad8d4":1,"chunk-4d794f61":1,"chunk-5880b66b":1,"chunk-6c14d94f":1,"chunk-792df3cc":1,"chunk-8934895a":1,"chunk-b6d1c046":1,"chunk-89394d6c":1,"chunk-8b81e078":1,"chunk-5bbfc239":1,"chunk-a01ae2aa":1,"chunk-cfdb0c12":1,"chunk-5af077ff":1,"chunk-77ed4564":1,"chunk-3b1e9d03":1,"chunk-4886ce14":1,"chunk-4e02f188":1,"chunk-5962841d":1,"chunk-65f17585":1,"chunk-6a4c442c":1,"chunk-6ac7ad44":1,"chunk-2c8bb25c":1,"chunk-7397d7f4":1,"chunk-8893d460":1,"chunk-8ba736a2":1,"chunk-179b2159":1,"chunk-2e8bcc3e":1,"chunk-48e6f5cb":1,"chunk-dc5ba90e":1,"chunk-e11f8508":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"WX-share":"WX-share"}[chunkId]||chunkId) + "." + {"chunk-2924e8bb":"be668510","chunk-3839168a":"31d6cfe0","chunk-01451fe6":"26ea4ac2","chunk-0292c992":"36e68060","chunk-40b44790":"eb6c6ad7","chunk-071eb884":"82cb3de3","chunk-1efd2608":"84309f52","chunk-278c4386":"ed45abc5","chunk-31594169":"e7983108","chunk-71a86922":"c589f760","chunk-3fd7c598":"4c733071","chunk-5ccc31a1":"a7ac78ef","chunk-5fc1159b":"c9622bbe","chunk-645be826":"d3409ed9","chunk-76c55559":"615428a2","chunk-7e980885":"34b76e26","chunk-9207c990":"e43795d8","chunk-33d3ca6e":"970a571a","chunk-3633e90e":"7cdd15eb","chunk-4a2ad8d4":"1e43ea4b","chunk-4d794f61":"6af1983c","chunk-5880b66b":"18e5dc5f","chunk-6c14d94f":"4ac87092","chunk-792df3cc":"13a9a33a","chunk-8934895a":"7178d7db","chunk-b6d1c046":"52540989","chunk-89394d6c":"07185656","chunk-8b81e078":"e51f9108","chunk-5bbfc239":"6a42a9ee","chunk-a01ae2aa":"08282b62","chunk-cfdb0c12":"59a522a9","chunk-5af077ff":"1a251cc7","chunk-77ed4564":"035db6f7","chunk-3b1e9d03":"27090d15","chunk-4886ce14":"873f152d","chunk-4e02f188":"22b4dcb1","chunk-5962841d":"53808f6d","chunk-65f17585":"e397cdc4","chunk-6a4c442c":"0ad85e32","chunk-6ac7ad44":"b8cb8918","chunk-2c8bb25c":"6d69052e","chunk-7397d7f4":"08dbae6a","chunk-8893d460":"ea68efa4","chunk-8ba736a2":"eeb35cbf","chunk-179b2159":"e1270cb5","chunk-2e8bcc3e":"4c25e23c","chunk-48e6f5cb":"f1fa8a37","chunk-dc5ba90e":"72c981a2","chunk-e11f8508":"397cfd07","WX-share":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//s20.lgstatic.com/edu/edu-fe/edu-growth-sem-fed/1.0.0/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
